export default {
  profile: {
    title: "My Profile",
    personalInfo: "Personal information",
    firstName: "First name",
    lastName: "Last name",
    firstNamePlaceholder: "Your first name",
    lastNamePlaceholder: "Your last name",
    email: "Email",
    emailHelp: "To change your email, contact your administrator.",
    changePassword: "Change password",
    passwordHelp: "Leave these fields blank if you don't want to change your password.",
    currentPassword: "Current password",
    newPassword: "New password",
    newPasswordPlaceholder: "At least 8 characters",
    confirmPassword: "Confirm new password",
    passwordsNoMatch: "Passwords don't match.",
    language: "Language",
    languageDesc: "Choose the language of the HelixScan interface.",
    languageNote: "PDF reports keep their own language, configurable when you generate them.",
    spanish: "Spanish",
    english: "English",
    saving: "Saving…",
    saveChanges: "Save changes",
    needCurrentPwd: "You must enter your current password.",
    pwdTooShort: "The new password must be at least 8 characters.",
    pwdMismatch: "The new password and its confirmation don't match.",
    saved: "Changes saved successfully.",
    saveError: "Error saving changes.",
  },
};
